<!-- Row View -->
@if (messageView === 'normal') {
  @if (fetchingAsset) {
    <div>
      <app-spinner></app-spinner>
    </div>
  }
  @if (!fetchingAsset) {
    <div class="col-sm-12">
      <p class="journey-description">{{ journeyContent.description }}</p>
      <div class="message-container">
        @if (copyType === 'message') {
          <p>Please select a message to copy:</p>
        }
        <ul [ngStyle]="{ 'width.px': ulWidth }">
          @for (step of filteredComponents; track step) {
            <li>
              <!-- Custom radio buttons or spacing for Smart Actions UI-->
              @if (selectionType === 'smart-actions-trigger' && !isIntegerStep(step.step)) {
                @if (isFirstPartOfStep(step.step)) {
                  <div class="radio-row">
                    <div class="radio-container" (click)="$event.stopPropagation()">
                      <input
                        type="radio"
                        name="triggerStep"
                        [value]="step.name"
                        [checked]="step.name === selectedStepId"
                        (change)="onStepSelected(step)"
                        />
                      @if (getTriggerType(step) === 'WorkflowDelayer') {
                        <img
                          src="assets/hex/delay.png"
                          alt="Delay Icon"
                          class="step-icon"
                          />
                      }
                      @if (getTriggerType(step) === 'APITrigger') {
                        <img
                          src="assets/hex/conditions.png"
                          alt="Conditions Icon"
                          class="step-icon"
                          />
                      }
                      <span class="radio-label">{{ step.nickname || '' }}</span>
                    </div>
                  </div>
                }
                @if (!isFirstPartOfStep(step.step)) {
                  <div
                    class="step-spacing"
                  ></div>
                }
              }
              <journey-step-preview
                [step]="step"
                [selectionType]="selectionType"
                [copyType]="copyType"
                [copyMsgParams]="copyMsgParams ? copyMsgParams : null"
                [highlight]="shouldHighlightStep(step)"
                [selectedStepId]="selectedStepId"
                [triggerType]="getTriggerType(step)"
                [journeyName]="journeyName"
                [journeyId]="journeyId"
                (stepActionSelected)="onStepActionSelected($event)"
                >
              </journey-step-preview>
            </li>
          }
        </ul>
      </div>
    </div>
  }
}

<!-- Grid View -->
@if (messageView === 'grid') {
  @if (fetchingAsset) {
    <div>
      <app-spinner></app-spinner>
    </div>
  }
  @if (!fetchingAsset) {
    <div>
      <p class="journey-description">{{ journeyContent.description }}</p>
      <div class="container-fluid" class="grid-details">
        <div class="row">
          <div class="col-sm-2">Nickname</div>
          <div class="col-sm-2 center">Date Created</div>
          <div class="col-sm-2 center">Date Modified</div>
          <div class="col-sm-3 center">ID</div>
        </div>
        @for (step of journeyContent.components; track step) {
          @if (
            step.type === 'MessageSender' ||
            step.type === 'MessageResponse' ||
            step.type === 'APITrigger'
            ) {
            <div class="row" [class.header-row]="step.type === 'APITrigger'">
              <div
                class="col-sm-2 message-name"
                [class.indent]="step.type !== 'APITrigger'"
                >
                {{ step.nickname
                }}@if (step.type === 'APITrigger') {
                <span class="trigger-icon"
                  >&nbsp;</span
                  >
                }
              </div>
              <div class="col-sm-2 center">
                {{ step.date_created | date: 'shortDate' }}
              </div>
              <div class="col-sm-2 center">
                {{ step.date_modified | date: 'shortDate' }}
              </div>
              @if (step.type === 'APITrigger') {
                <div class="col-sm-3 center">
                  <input
                    class="message-name"
                    id="{{ step.name }}"
                    value="{{ step.name }}"
                    spellcheck="false"
                    readonly
                    />
                </div>
                <div class="col-sm-2 copy-msg-wrapper">
                  <rn-copied-message
                    [copyFromElement]="true"
                    [customBtnText]="'Copy ID to Clipboard'"
                    [inputData]="step.name"
                  ></rn-copied-message>
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  }
}
